import { render, staticRenderFns } from "./VendorPrimarySiteCard.vue?vue&type=template&id=5b69915c"
import script from "./VendorPrimarySiteCard.vue?vue&type=script&lang=js"
export * from "./VendorPrimarySiteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports